import { post, post2, get } from "@/utils/https";
const api = "/xywapi";
// 全局图片上传
export async function uploadImg(data) {
  return await post(`${api}/upload/uploadImg`, data);
}

// 全局文件上传
export async function uploadFile(data) {
  return await post2(`${api}/upload/uploadFile`, data);
}
// 微信登录
export async function wechatLogin(data) {
  return await post(`${api}/user/wechatLogin`, data);
}
// 微信注册
export async function wechatRegister(data) {
  return await post(`${api}/user/wechatRegister`, data);
}
// 选手注册
export async function registerPlayer(data) {
  return await post(`${api}/user/registerPlayer`, data);
}
// 获取注册验证码
export async function getRegiserTelCode(telnum) {
  return await post(`${api}/user/registerGetTelCode/${telnum}`);
}
// 用户登录
export async function login(data) {
  return await post(`${api}/user/userLogin`, data);
}
// 关于我们
export async function getAboutUs(data) {
  return await post(`${api}/article/getAboutUs`, data);
}
//使用帮助
export async function getUseHelp(data) {
  return await post(`${api}/article/getUseHelp`, data);
}
export async function getUserAgreement(data) {
  return await post(`${api}/article/getUserAgreement`, data);
}
// 承诺书 授权书
export async function getArticleDetails(typeId) {
  return await post(`${api}/article/getArticleDetails/${typeId}`);
}
// 意见反馈
export async function submitFeedback(data) {
  return await post(`${api}/feedback/submitFeedback`, data);
}
// 验证账号密码
export async function checkPhonePwd(data) {
  return await post(`${api}/user/beforeChangeTel`, data);
}
// 换绑手机获取验证码
export async function getCodeBeforeChangeTel(data) {
  return await post(`${api}/user/getTelCodeByChangeTel`, data);
}
// 换绑手机
export async function userChangeTel(data) {
  return await post(`${api}/user/userChangeTel`, data);
}
// 修改密码获取验证码
export async function updPassGetTelCode(tel) {
  return await post(`${api}/user/updPassGetTelCode/${tel}`);
}
// 修改密码
export async function updPass(data) {
  return await post(`${api}/user/updPass`, data);
}
// 修改昵称
export async function updNickName(data) {
  return await post(`${api}/user/updNickName`, data);
}
// 修改头像
export async function updUserImg(data) {
  return await post(`${api}/user/updUserImg`, data);
}
// 我的宝贝
export async function getAllUserBaby(data) {
  return await post(`${api}/userBaby/getAllUserBaby`, data);
}
// 添加宝贝
export async function addUserBaby(data) {
  return await post(`${api}/userBaby/addUserBaby`, data);
}
// 解除绑定宝贝
export async function unbindParent(data) {
  return await post(`${api}/userWorks/unbindParent`, data);
}
// 查看宝贝详情
export async function getUserBabyDetails(id) {
  return await post(`${api}/userBaby/getUserBabyDetails/${id}`);
}
// 查看宝贝详情(新)
export async function getNewUserBabyDetails(id) {
  return await post(`${api}/userBaby/getNewUserBabyDetails/${id}`);
}
// 修改宝贝
export async function updUserBaby(data) {
  return await post(`${api}/userBaby/updUserBaby`, data);
}
// 我的报名服务单位列表
export async function getMyInstitution(data) {
  return await post(`${api}/institution/getMyInstitution`, data);
}
// 用户绑定报名服务单位
export async function bindInstitution(registerCode) {
  return await post(`${api}/institution/bindInstitution/${registerCode}`);
}
// 用户取消绑定
export async function unbindInstitution(id) {
  return await post(`${api}/institution/unbindInstitution/${id}`);
}
// 我的作品
export async function getMyWorks(data) {
  return await post(`${api}/userWorks/getMyWorks`, data);
}
// 我的通知
export async function getUserNotification(data) {
  return await post(`${api}/serNotification/getUserNotification`, data);
}
// 查看证书
export async function getWorksCertificate(id) {
  return await post(`${api}/userWorks/getWorksCertificate/${id}`);
}

// 查看团体证书
export async function getGroupCertUrl(id) {
  return await get(`${api}/userWorks/getGroupCertUrl/${id}`);
}

// 申请证书
export async function applyCert(data) {
  return await post(`${api}/userWorks/applyCert`, data);
}
// 标签图片
export async function labelPrint(id) {
  return await post(`${api}/userWorks/labelPrint/${id}`);
}
// 查看作品详情
export async function getWorksDetails(id) {
  return await post(`${api}/userWorks/getWorksDetails/${id}`);
}
// 查看作品详情 游客
export async function getReleaseWorksDetails(data) {
  return await post(`${api}/userWorks/getReleaseWorksDetails`, data);
}
// 点赞
export async function likeWorks(data) {
  return await post(`${api}/likeWorks/likeWorks`, data);
}
// 检查是否点赞
export async function checkLikeWorks(data) {
  return await post(`${api}/likeWorks/checkLikeWorks`, data);
}
// 获取用户附带数据
export async function personalData(data) {
  return await post(`${api}/user/personalData`, data);
}
// 获取用户附带数据
export async function replenishWorks(data) {
  return await post(`/pc/user/userWorks/replenishWorks`, data);
}

//删除作品
export async function h5DelWorks(id) {
  return await post(`${api}/userWorks/h5DelWorks/${id}`);
}

//搜索作品
export async function bindWorkList(data) {
  return await post(`${api}/userWorks/bindWorkList`,data);
}
//绑定作品
export async function bindWorks(data) {
  return await post(`${api}/userWorks/bindWorks`,data);
}
//绑定学生
export async function userBindBaby(data) {
  return await post(`${api}/userBaby/userBindBaby`,data);
}
//获取机构信息
export async function getDetail(code) {
  return await post(`${api}/institution/getDetail?code=`+code);
}
//获取活动信息
export async function getswActivityDetail(id) {
  return await post(`${api}/swActivity/getDetail?id=`+id);
}
// 意见反馈
export async function getfeedbackList(param) {
  return await post(`${api}/feedback/feedbackList`, param);
}
